import { useId, useRef } from 'react';
import useInlineScript from '@/hooks/useInlineScript';
import { IEmbedTikTok } from '@/types/IEmbeds';

export default function TikTok ({ id, nick }: IEmbedTikTok) {
  const ref = useRef<HTMLDivElement>(null);
  const timestampId = useId();

  useInlineScript(ref, `<script async src="https://www.tiktok.com/embed.js?${timestampId}"></script>`);

  return (
    <div ref={ref}>
      <blockquote
        cite={`https://www.tiktok.com/${nick}/video/${id}`}
        className={['tiktok-embed'].join(' ')}
        data-video-id={id}
        style={{ maxWidth: '605px', minWidth: '325px' }}
      >
        <section>
          <a href={`https://www.tiktok.com/${nick}?refer=embed`} rel='noreferrer' target='_blank' title={nick}>
            {nick}
          </a>
        </section>
      </blockquote>
    </div>
  );
}
